{
  "common": {
    "continue": "Endelea",
    "back": "Rudi",
    "next": "Ifuatayo",
    "skip": "Ruka",
    "loading": "Inapakia…",
    "logout": "Toka",
    "login": "Ingia",
    "signup": "Fungua akaunti",
    "or": "au",
    "email": "Barua pepe",
    "phone": "Simu",
    "password": "Nenosiri",
    "name": "Jina kamili",
    "portal": "Rudi kwenye portal",
    "language": "Lugha",
    "english": "Kiingereza",
    "swahili": "Kiswahili",
    "googleContinue": "Endelea na Google",
    "googleDisabled": "Kugusia Google hakujawekwa kwenye seva hii.",
    "mockContinue": "Endelea na data ya majaribio",
    "errorGeneric": "Kuna hitilafu. Jaribu tena.",
    "saving": "Inahifadhi…",
    "edit": "Hariri"
  },
  "onboarding": {
    "progress": "Hatua {{current}} kati ya {{total}}",
    "welcome": {
      "eyebrow": "Karibu",
      "title": "Pata tahadhari za mafuriko mapema",
      "body": "Chagua lugha yako. Unaweza kubadilisha baadaye.",
      "cta": "Anza"
    },
    "carousel": {
      "eyebrow": "Jinsi inavyofanya kazi",
      "slide1Title": "Fuatilia mahali unayojali",
      "slide1Body": "Nyumbani, kazini, shuleni — bila kufuatilia eneo lako moja kwa moja.",
      "slide2Title": "Tahadhari wazi za eneo",
      "slide2Body": "Mvua, mito, na maonyo rasmi kwa lugha rahisi.",
      "slide3Title": "Wewe unadhibiti",
      "slide3Body": "Chagua njia, saa za utulivu, na wakati wa kukuarifu.",
      "cta": "Fungua akaunti"
    },
    "signup": {
      "eyebrow": "Akaunti",
      "title": "Fungua akaunti ya {{name}}",
      "body": "Tumia simu au barua pepe. Google inapatikana ikishawekwa.",
      "haveAccount": "Tayari una akaunti?",
      "useOtp": "Unapendelea nambari ya SMS?"
    },
    "verify": {
      "eyebrow": "Thibitisha simu",
      "title": "Weka nambari tuliyotuma",
      "body": "Tulituma nambari yenye tarakimu 6 kwa {{phone}}.",
      "send": "Tuma nambari",
      "resend": "Tuma tena",
      "cta": "Thibitisha na endelea",
      "devOtp": "OTP ya majaribio",
      "consent": "Nakubali kupokea tahadhari za mafuriko kwa mahali nilipohifadhi. Maagizo rasmi ya dharura huwa yanatangulia."
    },
    "persona": {
      "eyebrow": "Kuhusu wewe",
      "title": "Utatumiaje programu hii?",
      "body": "Chagua moja au zaidi. Unaweza kubadilisha baadaye.",
      "driver": "Dereva",
      "rider": "Mpanda baiskeli / pikipiki",
      "resident": "Mkazi wa kila siku",
      "other": "Nyingine",
      "cta": "Endelea"
    },
    "alerts": {
      "title": "Mapendeleo ya tahadhari",
      "body": "Chagua jinsi tutakavyokufikia. Aina ya hatari, ukali na saa vinawekwa na mfumo.",
      "allAlertsInfo": "Utapokea tahadhari zote za maeneo yako na eneo ulipo, wakati wowote.",
      "channelSms": "SMS",
      "channelPush": "Arifa za simu",
      "channelWhatsapp": "WhatsApp",
      "channelEmail": "Barua pepe",
      "whatsappNeedsPhone": "Ongeza nambari ya simu kwanza ili kuwasha WhatsApp.",
      "whatsappOptIn": "Kuwasha hii ni idhini yako ya kupokea templates za tahadhari kwenye WhatsApp.",
      "alertLanguage": "Lugha ya tahadhari",
      "needChannel": "Washa angalau njia moja."
    },
    "phoneGate": {
      "title": "Ongeza nambari yako ya simu",
      "body": "Akaunti za Google zinahitaji nambari iliyothibitishwa kupokea tahadhari za SMS na WhatsApp.",
      "sendCode": "Tuma nambari",
      "verify": "Thibitisha",
      "verified": "Simu imethibitishwa",
      "phoneInUse": "Nambari hii ya simu tayari inatumika na akaunti nyingine.",
      "invalidOtp": "Nambari hiyo si sahihi au imekwisha muda wake.",
      "resend": "Tuma tena",
      "resendIn": "Tuma tena baada ya sekunde {{seconds}}",
      "changeNumber": "Badilisha nambari",
      "goHome": "Nenda nyumbani kwangu"
    },
    "done": {
      "title": "Umewekewa",
      "body": "Umewekewa kama {{persona}}. Tahadhari zinafuata mahali ulipo, kupitia {{channels}}.",
      "noChannels": "hakuna",
      "persona": "Jukumu",
      "alerts": "Tahadhari",
      "finishLater": "Malizia baadaye"
    }
  },
  "auth": {
    "residentLogin": "Ingia kama mkazi",
    "adminLogin": "Ingia kama msimamizi",
    "signupTitle": "Fungua akaunti",
    "callbackWorking": "Inakamilisha kuingia…",
    "forgotPassword": "Umesahau nenosiri",
    "forgotTitle": "Weka nenosiri jipya",
    "forgotBody": "Weka barua pepe ya akaunti yako. Tukiona akaunti, tutatuma kiungo cha kubadilisha nenosiri.",
    "forgotSent": "Ikiwa akaunti ipo kwa barua pepe hiyo, maelekezo yametumwa.",
    "sendReset": "Tuma kiungo",
    "resetTitle": "Chagua nenosiri jipya",
    "resetBody": "Tumia kiungo kutoka barua pepe, au bandika msimbo wa kubadilisha.",
    "resetCode": "Msimbo wa kubadilisha",
    "newPassword": "Nenosiri jipya",
    "confirmPassword": "Thibitisha nenosiri",
    "resetCta": "Hifadhi nenosiri",
    "resetDone": "Nenosiri limebadilishwa. Unaweza kuingia.",
    "passwordMismatch": "Manenosiri hayalingani.",
    "passwordShort": "Nenosiri liwe na herufi 8 au zaidi.",
    "backToLogin": "Rudi kuingia"
  },
  "prefs": {
    "title": "Mapendeleo",
    "messageLanguage": "Lugha ya ujumbe wa tahadhari",
    "messageLanguageHint": "Lugha ya SMS na barua pepe. Skrini za programu zinabaki Kiingereza au Kiswahili.",
    "minSeverity": "Kiwango cha chini cha tahadhari",
    "minSeverityHint": "Utapokea tahadhari za kiwango hiki au zaidi tu.",
    "severityLow": "Tahadhari zote — pamoja na hatari ndogo",
    "severityWatch": "Angalia na zaidi — mafuriko yanawezekana",
    "severityWarning": "Onyo na zaidi — mafuriko yanawezekana sana",
    "severitySevere": "Kali tu — mafuriko hatari",
    "channels": "Njia",
    "channelsHint": "Chagua jinsi unavyopokea taarifa. SMS bado inaheshimu jibu la STOP.",
    "loadError": "Imeshindwa kupakia mapendeleo kutoka seva.",
    "reportTitle": "Ripoti hatari",
    "reportHint": "Mafuriko au barabara isiyopitika? Shiriki mahali, maelezo mafupi, na picha ukipenda.",
    "reportCta": "Ripoti mwenyewe",
    "save": "Hifadhi mapendeleo",
    "saved": "Mapendeleo yamehifadhiwa",
    "saveError": "Imeshindwa kuhifadhi mapendeleo",
    "navHome": "Nyumbani",
    "navMap": "Ramani",
    "navAlerts": "Tahadhari",
    "navPrefs": "Mapendeleo"
  },
  "report": {
    "fab": "Ripoti",
    "title": "Ripoti hatari",
    "hazardType": "Aina ya hatari",
    "description": "Maelezo",
    "descriptionHint": "Eleza unachokiona (herufi 8–2000)",
    "placeName": "Jina la mahali (si lazima)",
    "location": "Mahali ulipo",
    "locationDetecting": "Inatafuta eneo…",
    "locationCaptured": "Eneo limepatikana",
    "locationUnavailable": "Eneo halipatikani — tafadhali washa GPS",
    "photo": "Picha (si lazima, upeo 2.5 MB)",
    "photoTooBig": "Picha iwe chini ya 2.5 MB",
    "submit": "Tuma ripoti",
    "submitted": "Ripoti imetumwa — asante!",
    "myReports": "Ripoti zangu",
    "noReports": "Hakuna ripoti bado.",
    "statusPending": "Inasubiri ukaguzi",
    "statusApproved": "Imekubaliwa",
    "statusRejected": "Haikukubaliwa",
    "hazards": {
      "FLOOD": "Mafuriko",
      "HEAVY_RAIN": "Mvua kubwa",
      "LIGHTNING": "Radi",
      "STRONG_WIND": "Upepo mkali",
      "HEAT": "Joto kali",
      "AIR_QUALITY_DUST": "Hewa / vumbi",
      "DROUGHT": "Ukame",
      "FIRE": "Moto",
      "EARTHQUAKE": "Tetemeko",
      "LANDSLIDE": "Kuporomoka kwa ardhi",
      "OTHER": "Nyingine"
    }
  },
  "map": {
    "title": "Ramani ya Hatari",
    "subtitle": "Inaonyesha tahadhari za maeneo uliyohifadhi",
    "legend": "Ufafanuzi",
    "filters": "Vichujio",
    "all": "Zote",
    "myLocation": "Mahali nilipo",
    "noAlerts": "Hakuna tahadhari zinazotumika katika eneo lako",
    "alertSheet": {
      "distance": "{{km}} km mbali",
      "source_official": "Rasmi",
      "source_advisory": "Ushauri",
      "source_report": "Ripoti ya jamii",
      "viewAll": "Ona tahadhari zote"
    },
    "counts": {
      "riskAreas": "Eneo {{count}} la hatari",
      "riskAreas_plural": "Maeneo {{count}} ya hatari",
      "activeAlerts": "Tahadhari {{count}} inayotumika",
      "activeAlerts_plural": "Tahadhari {{count}} zinazotumika",
      "approvedReports": "Ripoti {{count}}",
      "approvedReports_plural": "Ripoti {{count}}"
    }
  },
  "home": {
    "testAlertTitle": "Jaribu tahadhari zako",
    "testAlertHint": "Inatuma SMS yenye lebo TEST kwa simu yako. Upeo wa 3 kwa siku. Haitoi kwa analytics.",
    "testAlertCta": "Nitumie tahadhari ya jaribio",
    "testAlertSending": "Inatuma…",
    "testAlertQueued": "Tahadhari ya jaribio imetumwa. Angalia simu yako.",
    "testAlertError": "Imeshindwa kutuma tahadhari ya jaribio",
    "greeting_morning": "Habari za asubuhi, {{name}}",
    "greeting_afternoon": "Habari za mchana, {{name}}",
    "greeting_evening": "Habari za jioni, {{name}}",
    "currentWeather": "Hali ya hewa sasa",
    "feelsLike": "Inahisi kama {{temp}}°C",
    "humidity": "Unyevu {{pct}}%",
    "wind": "Upepo {{speed}} km/h",
    "rainChance": "Mvua {{pct}}%",
    "updatedAt": "Imesasishwa {{time}}",
    "riskCard": "Hatari kwa {{place}}",
    "noRisk": "Hakuna hatari kubwa ya mafuriko",
    "next24h": "Masaa 24 yajayo",
    "forecast3day": "Utabiri wa siku 3",
    "today": "Leo",
    "tomorrow": "Kesho",
    "dayAfter": "Kesho kutwa",
    "thresholdExplain": "ANGALIA imeanzishwa: {{reason}}",
    "activeAlerts": "Tahadhari {{count}} inayotumika",
    "activeAlerts_plural": "Tahadhari {{count}} zinazotumika",
    "viewAlerts": "Gusa kuona",
    "quickActions": "Vitendo vya haraka",
    "reportHazard": "Ripoti hatari",
    "planRoute": "Panga njia",
    "shareLocation": "Shiriki eneo",
    "emergency": "Nambari za dharura",
    "countyEmergency": "Dharura ya Kaunti ya {{county}}",
    "offline": "Nje ya mtandao — inaonyesha data iliyosasishwa {{time}}",
    "lastRefreshed": "Data imesasishwa mara ya mwisho: {{time}}",
    "refresh": "Sasisha"
  }
}
